export const SEARCH_PAGE_SIZE = 20;
export const SHARED_PAGE_SIZE = 20;
export const IMPORTED_PAGE_SIZE = 20;
export const UPDATES_PAGE_SIZE = 20;
export const FAVORITES_PAGE_SIZE = 20;
export const MANAGED_RESOURCES_PAGE_SIZE = 20;
export const STATS_PAGE_SIZE = 20;
export const FAVORITES_TRAY_PAGE_SIZE = 20;
